module.exports = __webpack_public_path__ + "static/4-a49f47eb35d4d68a0469dc630829473b.png";